// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__kR6oD","col":"styles_col__3D03S"};